module.exports = __webpack_public_path__ + "img/core_values-p-800.31d342af.png";